import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import './Pager.scss';

interface Props {
    count:number,
    page:number,
    perPage:number,
    changePage(page:number):void,
}

const Pager = (props:Props)=> {
    const change = (e: React.MouseEvent<HTMLElement>)=>{
        if( e.currentTarget.dataset.page ){
            props.changePage(parseInt(e.currentTarget.dataset.page));
        }
    }

    let page = props.page;
    const lastPage = Math.ceil(props.count/props.perPage)
    if( page>lastPage ){
        page = lastPage
    }
    if( page<1 ){
        page=1
    }
    const st = (page-1) * props.perPage + 1;
    let en = page * props.perPage;
    if( en>props.count ){
        en = props.count;
    }

    let prevOk = true;
    let nextOk = true;
    if( page===1 ){
        prevOk = false;
    }
    if( page===lastPage ){
        nextOk = false;
    }

    return (
        <div id="pager">
            <Grid container>
                <Grid item xs={6}>
                    {props.count>0 ? (
                    <div className="current">{st} - {en} / {props.count}</div>
                    ):(
                    <div className="current">まだない</div>
                    )}
                </Grid>
                <Grid item xs={6}><div className="action">
                <IconButton aria-label="prev" disabled={!prevOk} onClick={change} data-page={page-1} classes={{root:"active",disabled:"disabled"}}>
                    <ChevronLeftIcon/>
                </IconButton>
                <IconButton aria-label="next" disabled={!nextOk} onClick={change} data-page={page+1} classes={{root:"active",disabled:"disabled"}}>
                    <ChevronRightIcon/>
                </IconButton>
                </div>
                </Grid>
            </Grid>
        </div>
	);
}

export default Pager;